"use strict";

var CodeMirror = require('codemirror');

var _require = require('./capabilities.json'),
    builtins = _require.builtins;

CodeMirror.defineMode('rego', function (editorOptions, modeOptions) {
  var BUILTIN_REFERENCES_RE = new RegExp('\\b(?:' + builtins.filter(function (c) {
    return c.includes('.');
  }).join('|') + ')\\b');
  var BUILTINS_RE = new RegExp('\\b(?:' + builtins.filter(function (c) {
    return !c.includes('.');
  }).join('|') + ')\\b');
  var IDENTIFIER_RE = /^[A-Za-z_][A-Za-z_0-9]*/;
  var KEYWORDS_RE = /\b(?:as|default|else|import|not|with|some|in|every)\b/;
  var NUMBER_RE = /^-?(?:(?:(?:0(?!\d+)|[1-9][0-9]*)(?:\.[0-9]+)?)|(?:\.[0-9]+))(?:[eE][-+]?[0-9]+)?/;
  var OPERATOR_RE = /^(?:&|;|\*|\+|-|\/|%|=|:=|==|!=|<|>|>=|<=|\|)/;
  var SCALAR_RE = /\b(?:true|false|null)\b/;
  var ast = modeOptions.ast;
  var packagesByName = {};
  var rulesByName = {};

  if (ast) {
    packagesByName[ast["package"].getName()] = true;
    ast.imports.forEach(function (x) {
      return packagesByName[x.getName()] = true;
    });
    ast.rules.forEach(function (x) {
      return rulesByName[x.getName()] = true;
    });
  }

  function eatBuiltinReference(stream) {
    var match = stream.match(BUILTIN_REFERENCES_RE, false);

    if (match) {
      var n = match[0].lastIndexOf('.') + 1;
      var i = 0;
      stream.eatWhile(function () {
        return ++i < n;
      });
      return match[0].split('.').pop();
    }
  }

  function eatPathIdentifier(stream) {
    var identifier = eatIdentifier(stream);

    if (stream.eat('.')) {
      return;
    }

    return identifier;
  }

  function eatIdentifier(stream) {
    var match = stream.match(IDENTIFIER_RE);

    if (match) {
      return match[0];
    }
  }

  function eatString(stream) {
    var escaped = false;
    stream.eatWhile(function (c) {
      if (escaped) {
        escaped = false;
      } else {
        if (c === '"') {
          return false;
        } else if (c === '\\') {
          escaped = true;
        }
      }

      return true;
    });
    stream.eat('"');
  }

  function inBacktickString(stream, state) {
    var next;

    while (next = stream.next()) {
      // eslint-disable-line no-cond-assign
      if (next === '`') {
        state.tokenize = base;
        break;
      }
    }

    return 'string-2';
  }

  function base(stream, state) {
    if (stream.eatSpace()) {
      return;
    } else if (state.builtin) {
      stream.match(state.builtin);
      state.builtin = '';
      return 'builtin';
    } else if (state.inPackage) {
      if (stream.match(/\bas\b/)) {
        return 'keyword';
      }

      var identifier = eatPathIdentifier(stream);

      if (identifier) {
        state.inPackage = false;
        return 'variable-2';
      }
    } else if (state.inPath) {
      var _identifier = eatPathIdentifier(stream);

      if (_identifier) {
        state.inPath = false;
      }
    } else if (stream.eat('"')) {
      eatString(stream, state);
      return 'string';
    } else if (stream.eat('`')) {
      return (state.tokenize = inBacktickString)(stream, state);
    } else if (stream.eat('#')) {
      stream.skipToEnd();
      return 'comment';
    } else if (stream.match(/\bpackage\b/) || stream.match(/\bimport\b/)) {
      state.inPackage = true;
      return 'keyword';
    } else if (stream.match(KEYWORDS_RE)) {
      return 'keyword';
    } else if (stream.match(SCALAR_RE)) {
      return 'atom';
    } else if (stream.match(/\binput\b/)) {
      return 'variable-2';
    } else if (stream.match(NUMBER_RE)) {
      return 'number';
    } else if (stream.eat('.')) {
      state.inPath = true;
    } else {
      var builtin = eatBuiltinReference(stream);

      if (builtin) {
        state.builtin = builtin;
      } else {
        var _identifier2 = eatIdentifier(stream);

        if (_identifier2) {
          if (_identifier2 === '_') {
            return 'operator';
          } else if (BUILTINS_RE.test(_identifier2)) {
            return 'builtin';
          } else if (rulesByName[_identifier2]) {
            return 'def';
          } else if (packagesByName[_identifier2]) {
            return 'variable-2';
          }

          return 'variable';
        } else if (stream.match(OPERATOR_RE)) {
          return 'operator';
        }
      }

      stream.next();
    }

    if (stream.pos === stream.start) {
      // We weren’t able to tokenize anything and `stream` is in exactly the
      // same place as it was at the beginning of the `token()` call. One way
      // that this can happen is if the stream is syntactically invalid (e.g.,
      // `bar.[x]`). Whatever the cause, we need to skip past the problematic
      // character.
      stream.next();
    }
  }

  return {
    token: function token(stream, state) {
      return state.tokenize(stream, state);
    },
    startState: function startState() {
      return {
        builtin: '',
        inPackage: false,
        inPath: false,
        tokenize: base
      };
    },
    lineComment: '#'
  };
});
CodeMirror.defineMIME('application/rego', 'rego');
module.exports = {
  CodeMirror: CodeMirror
};